import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { MenuService } from '../common/menu.service';
import { MenuCategories } from '../common/menu.model';
import { Category, PurposeType, ResultType, YatraVM } from '../models/avbhakthi.model';
import { YatraService } from '../common/yatra.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-yatra-sandharshini',
  templateUrl: './yatra-sandharshini.component.html',
  styleUrls: ['./yatra-sandharshini.component.css']
})
export class YatraSandharshiniComponent implements OnInit, OnDestroy {
private serviceSubscriptions: Subscription;
  yatraSandharshini: YatraVM[];
  noMoreNews = false;
  contentLoading: boolean = true;
  constructor(
    private menuService: MenuService,
    private yatraService: YatraService
  ) {
    this.serviceSubscriptions = new Subscription();
    this.yatraSandharshini = [];
    this.serviceSubscriptions.add(
    this.yatraService
      .getYatras(10, Category.bhakthiNews, PurposeType.forMainScreen, false, ResultType.after)
      .subscribe(data => {
        this.contentLoading = false;
        if (data.length > 0) {
          // this.latestNews = data;
          this.yatraSandharshini = [...this.yatraSandharshini, ...data];
        } else {
          this.noMoreNews = true;
        }
      }, error => {
        // console.log(error);
        this.contentLoading = false;
      })
    );
    this.menuService.setMenuItems(MenuCategories.yatraSandharshini);
  }
  ngOnDestroy(): void {
    this.serviceSubscriptions.unsubscribe();
  }

  ngOnInit(): void {
  }

  @HostListener("window:scroll", ["$event"])
  onWindowScroll() {

    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight && !this.noMoreNews && !this.contentLoading) {
      // console.log('You have reached bottome of page');
      let lastNewsId = '';
      this.contentLoading = true;
      if (this.yatraSandharshini.length > 0 && this.yatraSandharshini.length > 0)
        lastNewsId = this.yatraSandharshini[this.yatraSandharshini.length - 1].YATRA_EXTERNAL_ID;
        this.serviceSubscriptions.add(
      this.yatraService
        .getYatras(10, Category.bhakthiNews, PurposeType.forMainScreen, false, ResultType.after, lastNewsId)
        .subscribe(data => {
          this.contentLoading = false;
          if (data.length > 0) {
            // this.latestNews = data;
            this.yatraSandharshini = [...this.yatraSandharshini, ...data];
          } else {
            this.noMoreNews = true;
          }
        }, error => {
          // console.log(error);
          this.contentLoading = false;
        })
        );
    }
  }
}
